"use client";

import { cn } from "@/lib/utils";
import { DynamicLucideIcon } from "@/components/icons/dynamic-lucide-icon";
import { HorizontalScrollRow } from "@/components/horizontal-scroll-row";

export interface CategoryPillItem {
  id: string;
  label: string;
  icon?: string;
  color?: string;
}

interface CategoryPillsProps {
  items: CategoryPillItem[];
  activeId?: string;
  onSelect: (id: string) => void;
}

export function CategoryPills({ items, activeId, onSelect }: CategoryPillsProps) {
  return (
    <HorizontalScrollRow className="pt-1">
      {items.map((item) => (
        <button
          key={item.id}
          onClick={() => onSelect(item.id)}
          className="shrink-0 flex flex-col items-center gap-1.5 w-[76px] hover:opacity-80 transition-opacity"
        >
          <div
            className={cn(
              "w-14 h-14 rounded-full flex items-center justify-center transition-all",
              !item.color && "bg-primary",
              activeId === item.id && "ring-2 ring-primary ring-offset-2",
            )}
            style={item.color ? { backgroundColor: item.color } : undefined}
          >
            {item.icon ? (
              <DynamicLucideIcon name={item.icon} size={24} className="text-white" />
            ) : (
              <span className="text-lg font-semibold text-white">{item.label.charAt(0)}</span>
            )}
          </div>
          <span className="text-xs font-medium text-center truncate w-full">
            {item.label}
          </span>
        </button>
      ))}
    </HorizontalScrollRow>
  );
}
